<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <div class="betting-record-page">
            <div class="common-header">
              <font style="vertical-align: inherit"
                ><font style="vertical-align: inherit"> {{ $t('mine.Redenvelope') }} </font></font
              >
            </div>

            <div class="betting-record-list-wrapper">
              <div class="common-list-wrapper">
                <div class="list-total-count" style="padding-left: 42px; box-sizing: border-box">
                  <div class="list-total-count-title">
                    <font style="vertical-align: inherit"
                      ><font style="vertical-align: inherit"> {{ $t('mine.Redsituation') }} </font></font
                    >
                  </div>
                  <ul class="data-list">
                    <li style="margin-left: 15px">
                      <span
                        ><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit"> {{ $t('mine.Accumulated') }} ：</font></font
                        ></span
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ userredpacket.acquirednum }}</font></font
                      >
                    </li>
                    <li>
                      <span
                        ><font style="vertical-align: inherit"
                          ><font style="vertical-align: inherit">{{ $t('mine.Remaining') }}</font></font
                        ></span
                      ><font style="vertical-align: inherit"
                        ><font style="vertical-align: inherit">{{ userredpacket.sendnums }}</font></font
                      >
                    </li>
                    <li>
                      <button type="button" class="el-button el-button--primary" @click="getwelfare">
                        <span
                          ><font style="vertical-align: inherit"
                            ><font style="vertical-align: inherit">{{ $t('mine.Receives') }}</font></font
                          ></span
                        >
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="list-wrapper">
              <div class="ant-table-wrapper">
                <div class="ant-spin-nested-loading">
                  <div class="ant-spin-container">
                    <div class="ant-table">
                      <div class="ant-table-container">
                        <div class="ant-table-content">
                          <table style="table-layout: auto">
                            <colgroup></colgroup>
                            <thead class="ant-table-thead">
                              <tr>
                                <th class="ant-table-cell col-api-type-id">{{ $t('mine.Recharge') }}</th>
                                <th class="ant-table-cell col-single-amount">{{ $t('mine.Redenvelopes') }}</th>
                                <th class="ant-table-cell col-profit-amount">{{ $t('mine.Rechargetimes') }}</th>
                                <th class="ant-table-cell col-profit-amount">{{ $t('mine.Collectiontime') }}</th>
                              </tr>
                            </thead>
                            <tbody class="ant-table-tbody" v-if="redpacketList.length > 0">
                              <tr class="ant-table-placeholder" v-for="(item, index) in redpacketList" :key="index">
                                <td>{{ item.money }}</td>
                                <td>{{ item.redpacketmoney }}</td>
                                <td>{{ item.created_at }}</td>
                                <td>{{ item.usetime }}</td>
                              </tr>
                            </tbody>
                            <tbody class="ant-table-tbody" v-if="redpacketList.length == 0">
                              <tr class="ant-table-placeholder">
                                <td colspan="8" class="ant-table-cell">
                                  <div class="empty-content">
                                    <span
                                      ><font style="vertical-align: inherit"
                                        ><font style="vertical-align: inherit">{{ $t('mine.Nodata') }}</font></font
                                      ></span
                                    >
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <el-pagination v-if="redpacketShowData.total" style="margin: 20px 0 0px 120px" @current-change="getredpacket" :current-page.sync="page" :page-size="10" layout="prev, pager, next" :total="redpacketShowData.total"></el-pagination>

                          <div style="height: 30px"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  name: 'welfare',
  data() {
    return {
      redpacketList: [],
      page: 1,
      redpacketShowData: {},
      userredpacket: {},
    };
  },
  created() {
    let that = this;
    that.getredpacket();
    that.getuserredpacket();
  },
  methods: {
    getwelfare() {
      let that = this;
      if (that.userredpacket.sendnums < 1) {
        that.$parent.showTost(0, that.$t('mine.havetrialss'));

        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/douserredpacket', {})
        .then(res => {
          console.log(res);

          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
          that.getredpacket();
          that.getuserredpacket();
        })
        .catch(() => {
          that.$parent.showTost(0, that.$t('mine.Servererrors'));
          that.$parent.hideLoading();
        });
    },

    getuserredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.get('/api/userredpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.userredpacket = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    // 获取红包记录
    getredpacket() {
      let that = this;
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun.post('/api/redpacket', info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.redpacketList = res.data.data;
          that.redpacketShowData = res.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/betting.css';
.spinner {
  width: 1em;
  height: 1em;
  position: relative;
  font-size: 200px;
  margin: 0 auto;
}

.spinner .line {
  width: 0.15em;
  height: 5px;
  border-radius: 5px;
  background-color: #b5b5b6;
  animation: spinner-line 1s infinite;
  position: absolute;
  right: 0;
  bottom: -0.1em;
}

.spinner svg {
  width: 1.2em;
  height: 1.2em;
  position: absolute;
  top: -0.1em;
  left: -0.1em;
  animation: spinner-jerry-fish 1s infinite;
  z-index: 1;
}

.spinner p {
  width: 100%;
  position: absolute;
  bottom: calc(-0.1em - 40px);
  text-align: center;
  height: 40px;
  line-height: 40px;
  margin: unset;
  display: flex;
  justify-content: center;
}

.spinner p span {
  font-size: 14px;
  color: #c9caca;
}

.spinner .circle {
  width: 1em;
  height: 1em;
  border-radius: 50%;
}

.spinner .circle i {
  position: absolute;
  left: 0;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  animation: spinner-circle-clipper linear 1s infinite;
}

.spinner .circle i:after {
  position: absolute;
  left: 0;
  clip: rect(0, 1em, 1em, 0.5em);
  width: 1em;
  height: 1em;
  content: '';
  animation: spinner-circle 1s linear infinite;
  border-radius: 50%;
  box-shadow: inset 0 0 0 4px #c9caca;
}

@keyframes spinner-circle-clipper {
  0% {
    transform: rotate(0deg);
  }
  30% {
    transform: rotate(60deg);
  }
  50% {
    transform: rotate(60deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes spinner-circle {
  0% {
    transform: rotate(-180deg);
  }
  5% {
    transform: rotate(-170deg);
  }
  30% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(30deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes spinner-jerry-fish {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-line {
  0% {
    opacity: 0;
    right: 0;
  }
  5% {
    opacity: 0.2;
  }
  10% {
    opacity: 0.4;
  }
  15% {
    opacity: 0.6;
  }
  20% {
    opacity: 0.8;
  }
  25% {
    opacity: 1;
  }
  30% {
    opacity: 1;
  }
  35% {
    opacity: 0.8;
  }
  40% {
    opacity: 0.6;
  }
  45% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.3;
  }
  55% {
    opacity: 0.2;
  }
  60% {
    opacity: 0.1;
  }
  65% {
    opacity: 0;
    right: calc(100% - 0.25em);
  }
  100% {
    opacity: 0;
    right: 0;
  }
}
.active {
  color: #fff !important;
}
.ant-table-thead > tr > th {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/welfare.vue